<template>
	<GrigliaContabile modulo="costi" />
</template>

<script>
import GrigliaContabile from './GrigliaContabile.vue'

export default {
	name: "Costi",
	components: { GrigliaContabile },
}
</script>
